import parse from 'html-react-parser';
import { useRef, useState } from 'react';

import { slideUp, slideDown } from '~globals/common';

type Props = { children: React.ReactNode; cta: string };

const DropdownCta = ({ children, cta }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null as null | HTMLDivElement);

    const toHtml = (p: string) => {
        return parse(p);
    };

    const toggleContent = () => {
        if (!contentRef.current) {
            return;
        }
        isOpen ? slideUp(contentRef.current) : slideDown(contentRef.current);
        setIsOpen(!isOpen);
    };

    return (
        <div>
            <button className="text-link mb-4" onClick={toggleContent}>
                <span>{toHtml(cta)}</span>
            </button>
            <div style={{ display: 'none' }} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};

export default DropdownCta;
